'use client';

import { useLayoutEffect } from 'react';
import { textDirection } from '@/i18n/routing';

type DocumentLocaleProps = {
  locale: string;
};

/**
 * Syncs `<html lang dir>` (and optional locale class) from the `[locale]` segment.
 * Root `layout.tsx` cannot read dynamic params under static export; this runs on the
 * client immediately after the server-rendered subtree for the active locale is known.
 */
export function DocumentLocale({ locale }: DocumentLocaleProps) {
  const dir = textDirection(locale);

  useLayoutEffect(() => {
    const root = document.documentElement;
    root.lang = locale;
    root.dir = dir;
    root.classList.remove('locale-en', 'locale-ar');
    root.classList.add(`locale-${locale}`);
  }, [locale, dir]);

  return null;
}
